<template>
    <rkm-table
        :fields="fields"
        :items="data.model.odontograma.dentesSupranumerarios"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(procedimentos)="{item}">
            {{ item.procedimentosClinicos.map(p => p.procedimento.nome).join(', ') }}
        </template>

        <template
            v-if="!data.readonly"
            v-slot:cell(actions)="{index, item}"
        >
            <rkm-button
                @click="$emit('edit', item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {
        fields() {
            const fields = [
                {key: 'local', label: 'Local', sortable: true},
                {key: 'procedimentos', label: 'Procedimentos'},
                {key: 'observacao', label: 'Observações'},
            ]

            if (!this.data.readonly) {
                fields.push({class: 'col-min text-center', key: 'actions', label: 'Ações'})
            }

            return fields
        },
    },
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o dente supranumerário?', async () => {
                this.data.model.odontograma.dentesSupranumerarios.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
